module.exports = __webpack_public_path__ + "static/img/Body-13.44569c42.jpg";